import React, { useEffect, useState } from 'react';
import { fetchMe, getStoredToken } from '../../services/authService';

/**
 * Token usage after evaluation. Estimated cost is shown to admins only.
 */
export default function EvaluationUsageView({ usage }) {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!getStoredToken()) {
      setIsAdmin(false);
      return undefined;
    }
    fetchMe()
      .then((me) => {
        if (!cancelled) setIsAdmin(me?.role === 'ADMIN');
      })
      .catch(() => {
        if (!cancelled) setIsAdmin(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!usage) return null;

  const { promptTokens, completionTokens, totalTokens, estimatedCostUsd } = usage;
  const parts = [];
  if (promptTokens != null || completionTokens != null) {
    parts.push(`${promptTokens ?? 0} prompt, ${completionTokens ?? 0} completion`);
  }
  if (totalTokens != null) parts.push(`${totalTokens} total`);
  if (isAdmin && estimatedCostUsd != null) {
    parts.push(`Est. cost: $${estimatedCostUsd.toFixed(4)}`);
  }
  if (parts.length === 0) return null;

  return <div className="resume-subpage__usage">{parts.join(' · ')}</div>;
}
